module.exports = __webpack_public_path__ + "assets/img/29_231_big.4f8096ca.jpg";